import { Typography } from "@mui/material";
import React from "react";
import { Container, Field, Label, FromToContainer } from "../ProformaEmployeeCostReport/EmployeeCostHeader/styles";

interface Props {
  // project: string;
  // employee: string;
  description: string;
  currency: string;
  from: string;
  // to: string;
}

const ExportedProformaEmployeeCostReportHeader = ({
  // project,
  // employee,
  description,
  currency,
  from,
}: // to
Props) => {
  return (
    <>
      <Container>
        <Field>
          <Label>Description</Label>
          <Typography>{description}</Typography>
        </Field>
        {/* <Field>
          <Label>Project</Label>
          <Typography>{project}</Typography>
        </Field> */}
        <Field>
          <Label>Currency</Label>
          <Typography>{currency}</Typography>
        </Field>
        {/* <Field>
          <Label>Employee</Label>
          <Typography>{employee}</Typography>
        </Field> */}
        <FromToContainer>
          <Field>
            <Label>Valid as of</Label>
            <Typography>{from}</Typography>
          </Field>
          {/* <Field>
            <Label>To</Label>
            <Typography>{to}</Typography>
          </Field> */}
        </FromToContainer>
      </Container>
    </>
  );
};

export default ExportedProformaEmployeeCostReportHeader;
